import SigningModal from './signing-modal';
import PayerModal from './payer-modal';
import EmployerModal from './employer-modal';
import InsuranceTakerModal from './insurance-taker-modal';
import DeathbenefitsBeneficiaryModal from './deathbenefits-beneficiary-modal';
import MultiAnsModal from './multi-ans-modal';
import AdditionalQuestionsModal from './additional-questions-modal';
import ConditionalModal from './conditional-modal';


export {
    SigningModal,
    PayerModal,
    EmployerModal,
    InsuranceTakerModal,
    DeathbenefitsBeneficiaryModal,
    MultiAnsModal,
    AdditionalQuestionsModal,
    ConditionalModal
} 